import React from 'react';
import PropTypes from 'prop-types';
import format from 'date-fns/format';
import style from './style.css';

const Fortress = window.cccisd.fortress;

const Header = props => {
    const { student } = props;

    return (
        <div className={style.header}>
            <div className={style.logo} />
            <div className={style.paramsWrapper}>
                <div className={style.params}>
                    <div>
                        <b>Student:</b>
                        {student.name}
                    </div>
                    <div>
                        <b>Student ID:</b>
                        {student.studentId}
                    </div>
                    <div>
                        <b>School:</b>
                        {student.school}
                    </div>
                </div>
                <div className={style.separator} />
                <div className={style.params}>
                    <div>
                        <b>Report Created:</b>
                        {format(new Date(), 'yyyy-MM-dd')}
                    </div>
                    <div>
                        <b>Current Provider:</b>
                        {Fortress.user.acting.user.full_name}
                    </div>
                </div>
            </div>
        </div>
    );
};

Header.propTypes = {
    student: PropTypes.object,
};

export default Header;
